(() => {
  if (window.cvCapsuleCovers) {
    window.cvCapsuleCovers.refresh();
    return;
  }

  const rootPath = document.querySelector('script[data-capsule-covers-root]')?.dataset.capsuleCoversRoot || '/';
  const tags = new Map([
    ['elegant-casual-auto', '#capacapec'],
    ['mediterraneo-chic-auto', '#capacapmc'],
    ['modern-heritage', '#capacapmh'],
    ['denim-streetwear-auto', '#capacapds'],
    ['dress-to-impress-auto', '#capacapdi']
  ]);
  const requests = new Map();
  const pending = new WeakSet();

  function collectionTag(link) {
    if (!link) return null;
    const url = new URL(link.getAttribute('href'), window.location.origin);
    if (url.origin !== window.location.origin) return null;
    const match = url.pathname.match(/\/collections\/([^/]+)/);
    return match ? tags.get(match[1]) : null;
  }

  function coverUrl(path) {
    const url = new URL(path, window.location.origin);
    if (url.origin !== window.location.origin || !url.pathname.includes('/collections/all')) {
      throw new Error('Invalid capsule cover URL');
    }
    url.searchParams.set('section_id', 'capsule-card-cover');
    url.searchParams.set('sort_by', 'created-descending');
    const preview = new URL(window.location.href).searchParams.get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    return url;
  }

  async function findCover(tag) {
    let path = rootPath.replace(/\/?$/, '/') + 'collections/all/' + tag.slice(1);
    const visited = new Set();
    while (path) {
      const url = coverUrl(path);
      if (visited.has(url.href)) throw new Error('Repeated capsule cover page');
      visited.add(url.href);
      const response = await fetch(url, { signal: AbortSignal.timeout(15000) });
      if (!response.ok) throw new Error('Capsule cover unavailable');
      const result = new DOMParser().parseFromString(await response.text(), 'text/html')
        .querySelector('template[data-capsule-cover-result]');
      if (!result) throw new Error('Missing capsule cover response');
      if (!result.dataset.coverTag && !result.dataset.productId) return null;
      if (result.dataset.coverTag !== tag) throw new Error('Wrong capsule cover tag');
      const image = result.content.querySelector('img');
      if (image && result.dataset.productId) return { image, productId: result.dataset.productId };
      path = result.dataset.nextUrl || '';
    }
    return null;
  }

  function preload(image) {
    return new Promise((resolve, reject) => {
      const probe = new Image();
      const timer = setTimeout(() => reject(new Error('Capsule image timed out')), 15000);
      probe.onload = () => { clearTimeout(timer); resolve(); };
      probe.onerror = () => { clearTimeout(timer); reject(new Error('Capsule image unavailable')); };
      probe.src = image.getAttribute('src');
    });
  }

  async function updateCover(container, tag) {
    if (!container || !tag || pending.has(container) || container.dataset.capsuleCoverProduct) return;
    pending.add(container);
    container.dataset.capsuleCoverTag = tag;
    try {
      if (!requests.has(tag)) {
        requests.set(tag, findCover(tag).then(async result => {
          if (result) await preload(result.image);
          return result;
        }));
      }
      const result = await requests.get(tag);
      if (!result || !container.isConnected) return;
      let image = container.querySelector('img');
      if (!image) {
        image = document.createElement('img');
        image.className = 'theme-img';
        image.style.cssText = 'width:100%;height:100%;object-fit:cover';
        container.replaceChildren(image);
      }
      image.removeAttribute('data-manual-src');
      image.removeAttribute('data-manual-srcset');
      for (const name of ['srcset', 'src', 'alt', 'width', 'height']) {
        const value = result.image.getAttribute(name);
        if (value === null) image.removeAttribute(name);
        else image.setAttribute(name, value);
      }
      container.dataset.capsuleCoverProduct = result.productId;
    } catch (error) {
      requests.delete(tag);
    } finally {
      pending.delete(container);
    }
  }

  function refresh() {
    document.querySelectorAll('.homepage-capsules .collection-block').forEach(card => {
      updateCover(card.querySelector('.product-block__image, .image-cont > .placeholder-image'),
        collectionTag(card.querySelector('a.product-link')));
    });
    document.querySelectorAll('.navigation__capsules-hero, .navigation__wide-promotion').forEach(promo => {
      updateCover(promo.querySelector('.navigation__capsules-hero-media, .container__breakout'),
        collectionTag(promo.querySelector('.button-row a')));
    });
    document.querySelectorAll('.navigation__capsules-side-promo, .navigation__column--promotion .menu-promotion, .navigation__column--promotion-carousel .menu-promotion').forEach(promo => {
      updateCover(promo.querySelector('.menu-promotion__image'),
        collectionTag(promo.querySelector('a.menu-promotion__link')));
    });
  }

  window.cvCapsuleCovers = { refresh };
  document.addEventListener('shopify:section:load', refresh);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, { once: true });
  else refresh();
})();
